import { Paper, Tooltip } from "@material-ui/core";
import MaterialTable from "material-table";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FiCheck, FiCpu, FiEdit, FiTrash2, FiUser, FiX } from "react-icons/fi";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import {
  ErrorUnexpected,
  OperationSuccessfully,
} from "../../../../../../../const/Messages";
import * as TemplateService from "../../../../../../../service/TemplateEricssonHlrService";

/**
  @author Guilherme Almeida
  @date 08/03/2021
 */
export default function TemplateEricssonHLRList() {
  const history = useHistory();
  const [template, setTemplate] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    TemplateService.findAll()
      .then((templateList) => {
        setTemplate(templateList);
      })
      .catch(() => {
        toast.error(ErrorUnexpected);
      })
      .finally(() => setIsLoading(false));
  }, []); // eslint-disable-line

  function handleDelete(id) {
    Swal.fire({
      icon: "warning",
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        TemplateService.deleteById(id)
          .then(() => {
            TemplateService.findAll()
              .then((templateList) => {
                setTemplate(templateList);
                toast.success(OperationSuccessfully);
              })
              .catch(() => {
                toast.error(ErrorUnexpected);
              });
          })
          .catch(() => {
            toast.error(ErrorUnexpected);
          });
      }
    });
  }

  const columns = [
    {
      title: "Global Title Prefix",
      field: "gt",
    },
    {
      title: "TADIG",
      field: "plmn.name",
      render: (row) => (row.plmn && row.plmn.name ? row.plmn.name : "-"),
    },
    {
      title: "ROAMREST",
      field: "roamrest",
      lookup: { true: "Active", false: "Inactive" },
      customSort: (a, b) => (a.roamrest === b.roamrest ? 0 : a.roamrest ? -1 : 1),
      render: (row) =>
        row.roamrest ? (
          <span
            className="badge badge-success p-1 px-2 d-inline-flex align-items-center"
            style={{ fontSize: "12px" }}
          >
            <FiCheck className="mr-1" /> Active
          </span>
        ) : (
          <span
            className="badge badge-danger p-1 px-2 d-inline-flex align-items-center"
            style={{ fontSize: "12px" }}
          >
            <FiX className="mr-1" /> Inactive
          </span>
        ),
      width: "1%",
    },
    {
      title: "Description / Reason",
      field: "description",
      render: (row) => (row.description ? row.description : "-"),
    },
    {
      title: "Modified by",
      field: "userName",
      render: (row) => {
        if (!row.userName) return <span className="text-muted">-</span>;
        if (row.userName.toUpperCase() === "SYSTEM") {
          return (
            <Tooltip
              title={
                row.description
                  ? `Automatic deactivation: ${row.description}`
                  : "Automatic system action"
              }
              placement="top"
            >
              <span
                className="badge badge-warning p-1 px-2 d-inline-flex align-items-center"
                style={{ fontSize: "12px", cursor: "help" }}
              >
                <FiCpu className="mr-1" /> SYSTEM
              </span>
            </Tooltip>
          );
        }
        return (
          <span
            className="badge badge-secondary p-1 px-2 d-inline-flex align-items-center"
            style={{ fontSize: "12px" }}
          >
            <FiUser className="mr-1" /> {row.userName}
          </span>
        );
      },
    },
  ];

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title d-flex justify-content-between align-items-center">
            <h5>Template - Ericsson HLR - Roamrest</h5>
            <div>
              <Link
                className="btn btn-primary"
                to={{
                  pathname:
                    "/settings/report/template/hlr/ericsson/template/reg",
                  state: { id: "" },
                }}
              >
                New Template
              </Link>
            </div>
          </div>
          <div className="ibox-content">
            <MaterialTable
              title=""
              columns={columns}
              data={template}
              isLoading={isLoading}
              components={{
                Container: (props) => <Paper {...props} elevation={0} />,
              }}
              options={{
                rowStyle: {
                  fontSize: 13,
                },
                pageSize: 10,
                pageSizeOptions: [5, 10, 15, 20],
                actionsColumnIndex: -1,
                exportButton: true,
                exportAllData: true,
                searchFieldAlignment: "left",
                toolbarButtonAlignment: "right",
                exportFileName: "template-hlr-ericsson",
                filtering: true,
                headerStyle: {
                  textTransform: "uppercase",
                },
              }}
              actions={[
                {
                  icon: () => <FiEdit size={16} color="#007bff" />,
                  tooltip: "EDIT",
                  onClick: (event, rowData) =>
                    history.push(
                      "/settings/report/template/hlr/ericsson/template/reg",
                      { id: rowData.id }
                    ),
                },
                {
                  icon: () => <FiTrash2 size={16} color="#007bff" />,
                  tooltip: "DELETE",
                  onClick: (event, rowData) => handleDelete(rowData.id),
                },
              ]}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
